import { useSiteContext } from '@dustin-web/microsite-components/src/hooks'
import { FormattedCurrency } from '@dustin-web/microsite-components/src/i18n'

type Props = {
  price: number
}

const ProductVariantPrice = ({ price }: Props) => {
  const { sourcingCompany } = useSiteContext()

  const showRoundedPrice =
    sourcingCompany === 'SE' || sourcingCompany === 'NO' || sourcingCompany === 'DK'

  return (
    <small>
      <FormattedCurrency amount={showRoundedPrice ? Math.round(price) : price} />
    </small>
  )
}

export default ProductVariantPrice
